import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { VoiceChangeInfo, VoiceSubscriptionOffering } from '@sales/modules/subscription/models/offerings-response.model';
import { PriceType } from '@shared/pipes/price-format.pipe';
import { FormGroupDirective, ControlContainer, AbstractControl } from '@angular/forms';
import { Subscriber } from '@shared/models/subscriber.model';
import { getAgeLimitStatus } from '@sales/validators/age.validator';
import { BenefitProgram } from '@shared/enums/benefit-program-type.enum';
import { Seller } from '@core/models/dealer.model';
import { Sponsor, SponsorType } from '@shared/models/sponsor.model';
import { Messages } from '@app/shared/enums/termination-messages';
import { AssignedSubscriptionModel } from '@app/shared/models/assigned-subscription-offering.model';
import { SubscriptionHelperService } from '@app/sales/services/subscription-helper.service';
import { PriceFormatPipe } from '@app/shared/pipes/price-format.pipe';
import { DatePipe } from '@angular/common';
import { IceBadgeComponent } from '@app/shared/components/atoms/ice-badge/ice-badge.component';
import { BenefitProgramOptionsComponent } from './benefit-program-options/benefit-program-options.component';
import { IceInfoIconComponent } from '@app/shared/components/atoms/ice-info-icon/ice-info-icon.component';
import { MatTooltip } from '@angular/material/tooltip';
import { IceRadioListItemComponent } from '@app/shared/components/atoms/ice-radio-list-item/ice-radio-list-item.component';

@Component({
  selector: 'app-voice-offering-item',
  templateUrl: './voice-offering-item.component.html',
  styleUrls: ['./voice-offering-item.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  imports: [
    IceRadioListItemComponent,
    MatTooltip,
    IceInfoIconComponent,
    BenefitProgramOptionsComponent,
    IceBadgeComponent,
    DatePipe,
    PriceFormatPipe,
  ],
})
export class VoiceOfferingItemComponent implements OnChanges {
  PriceType = PriceType;
  Messages = Messages;
  BenefitProgram = BenefitProgram;
  SubscriptionBindingExpirationDate = SubscriptionHelperService.subscriptionBindingExpirationDate;

  @Input() offering: VoiceSubscriptionOffering;
  @Input() changeInfo: VoiceChangeInfo;
  @Input() assignedSubscription: AssignedSubscriptionModel = null;
  @Input() isExistingOffering: boolean = false;
  @Input() isExistingSubscription: boolean = false;
  @Input() subscriber: Subscriber;
  @Input() control: AbstractControl;
  @Input() sponsor: Sponsor;
  @Output() sponsorSelected = new EventEmitter<Seller>();
  @Output() sponsorTypeSelected = new EventEmitter<SponsorType>();

  subscriberExceedsUpperAgeLimit: boolean;
  subscriberIsBelowLowerAgeLimit: boolean;

  get isDisabled(): boolean {
    return this.isExistingSubscription && (this.subscriberExceedsUpperAgeLimit || this.subscriberIsBelowLowerAgeLimit);
  }

  get tooltipMessage(): string {
    if (this.isExistingSubscription && (this.subscriberExceedsUpperAgeLimit || this.subscriberIsBelowLowerAgeLimit)) {
      const isAbove = this.subscriberExceedsUpperAgeLimit;
      const ageLimit = isAbove ? this.offering.upperAgeLimit : this.offering.lowerAgeLimit;
      const comparison = isAbove ? 'over' : 'under';

      return `Bruker er ${comparison} ${ageLimit} år og kan ikke kjøpe ${this.offering.name}`;
    }

    return '';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.offering && this.offering) {
      const { exceedsUpperAgeLimit, isBelowLowerAgeLimit } = getAgeLimitStatus(this.subscriber?.birthday, this.offering);
      this.subscriberExceedsUpperAgeLimit = exceedsUpperAgeLimit;
      this.subscriberIsBelowLowerAgeLimit = isBelowLowerAgeLimit;
    }
  }

  get existingBindingWillBeTransferred(): boolean {
    return !!(
      this.isExistingSubscription &&
      !this.changeInfo?.triggersBreakageFee &&
      this.SubscriptionBindingExpirationDate(this.assignedSubscription)
    );
  }
}
